import { createApp } from 'vue'
import options from './TheHeader.options'

const el = '.kb-component--the-header'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM && !DOM.hasAttribute('data-v-app')) {
        const component = createApp(options).use(Store)

        const donateButton = DOM.querySelector('.kb-js--donate-button')
        const donationSettings = donateButton?.dataset.donationSettings
        if (donationSettings)
            Store.commit(
                'fundraising/set_donation_settings',
                JSON.parse(donationSettings)
            )

        const template = DOM.outerHTML
        options.template = template
        component.mount(el)
    }
}
